import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircleHelpIcon } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "./Tooltip";
export var HelpTooltip = function (_a) {
    var content = _a.content, _b = _a.iconClassName, iconClassName = _b === void 0 ? "size-3.5" : _b;
    return (_jsxs(Tooltip, { durationPreset: "instant", children: [_jsx(TooltipTrigger, { children: _jsx(CircleHelpIcon, { className: "".concat(iconClassName, " cursor-help text-tertiary") }) }), _jsx(TooltipContent, { className: "max-w-80 text-xs", children: content })] }));
};
